import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { slide } from '../../../styles/animations';
import { ButtonComponent } from '@app/shared/button/button.component';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-home-carousel',
  standalone: true,
  imports: [CommonModule, ButtonComponent, CarouselModule, ProgressSpinnerModule],
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.scss'],
  animations: [slide],
})
export class HomeCarouselComponent {
  @Input() items: any[] = [];
  @Input() template: TemplateRef<any> | null = null;
  @Input() templateHeader: TemplateRef<any> | null = null;
  @Input() itemsPerSlide: number = 4;
  @Input() width: string = '100%';
  @Input() headerTitle: string;
  @Input() buttonsDirection: 'bottom-center' | 'top-right' | 'space-between' | 'right-center' | 'bottom-right' = 'bottom-center';
  @Input() loading: boolean;
  @Input() isShowArrow = true;
  @Input() isMobile: boolean;
  @Input() itemsMargin: number;
  @Input() isBtnShowAll = false;
  @Input() currentIndex: number = 0;

  @Output() lastScrollEmit: EventEmitter<number> = new EventEmitter<number>();
  @Output() showAllEmit: EventEmitter<any> = new EventEmitter<any>();

  loadDataIndex = 0;

  constructor() {
    Carousel.prototype.onTouchMove = () => {};
  }
  get numScroll() {
    return Math.floor(this.itemsPerSlide);
  }

  get leftMargin() {
    return !this.itemsMargin ? (this.isMobile ? 8 : 32) : this.itemsMargin;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides();
    if (this.currentIndex + 1 === this.totalSlides()) {
      this.loadDataIndex++;
      this.lastScrollEmit.emit(this.loadDataIndex);
    }
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides()) % this.totalSlides();
  }

  showButtons() {
    return this.currentIndex + 1 < this.totalSlides();
  }

  totalSlides() {
    return this.items ? Math.ceil(this.items.length / this.itemsPerSlide) : 0;
  }

  getGlobalIndex(localIndex: number): number {
    return this.currentIndex * this.itemsPerSlide + localIndex;
  }

  shawALL() {
    this.showAllEmit.emit();
  }
}
